import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e673298c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "wrapper-block"
}
const _hoisted_2 = { class: "container-block-img" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "recipe-info" }
const _hoisted_5 = { class: "container-time" }
const _hoisted_6 = { class: "container-time" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "container-time" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "container-title" }
const _hoisted_11 = { class: "recipe-creation-date" }
const _hoisted_12 = {
  key: 0,
  class: "container-user"
}
const _hoisted_13 = { class: "container-tags-private" }
const _hoisted_14 = { class: "container-private" }
const _hoisted_15 = {
  key: 0,
  class: "recipe-icons-archive-delete"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Restore", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Delete", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoaderCircle = _resolveComponent("LoaderCircle")!
  const _component_UserIconName = _resolveComponent("UserIconName")!
  const _component_TagsContainer = _resolveComponent("TagsContainer")!
  const _component_EyeOffIcon = _resolveComponent("EyeOffIcon")!
  const _component_ReplyIcon = _resolveComponent("ReplyIcon")!
  const _component_DocumentRemoveIcon = _resolveComponent("DocumentRemoveIcon")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_LoaderCircle, { key: 0 }))
      : (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (_ctx.recipe.images && _ctx.recipe.images.length > 0)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  id: "compact-block-img",
                  src: _ctx.recipe.images.find((image) => image.index === 0).url || '',
                  alt: _ctx.recipe.title + ' image'
                }, null, 8, _hoisted_3))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("img", {
                  class: "time-icons",
                  src: require('@/assets/chopping-board.png')
                }, null, 8, _hoisted_7),
                _createElementVNode("span", null, _toDisplayString(_ctx.recipe.prepTime) + " mins", 1)
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("img", {
                  class: "time-icons",
                  src: require('@/assets/cooking-time.png')
                }, null, 8, _hoisted_9),
                _createElementVNode("span", null, _toDisplayString(_ctx.recipe.cookTime) + " mins", 1)
              ])
            ]),
            _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.recipe.title), 1),
            _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.creationDateFormatted), 1),
            (_ctx.recipe.authorId !== _ctx.contextUser._id)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createVNode(_component_UserIconName, {
                    "profile-picture": _ctx.recipeAuthorImage,
                    name: _ctx.recipeAuthorName,
                    "image-dimensions": 30,
                    "font-size": 0.7,
                    padding: 5
                  }, null, 8, ["profile-picture", "name", "font-size"])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_TagsContainer, { tags: _ctx.tags }, null, 8, ["tags"]),
              _createElementVNode("div", _hoisted_14, [
                (_ctx.recipe.isPrivate)
                  ? (_openBlock(), _createBlock(_component_EyeOffIcon, { key: 0 }))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          (_ctx.showRestore)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createElementVNode("div", {
                  id: "recipe-icon-archive",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.restore && _ctx.restore(...args)))
                }, [
                  _createVNode(_component_ReplyIcon),
                  _hoisted_16
                ]),
                _createElementVNode("div", {
                  id: "recipe-icon-delete",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.remove && _ctx.remove(...args)))
                }, [
                  _createVNode(_component_DocumentRemoveIcon),
                  _hoisted_17
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
  ]))
}